<template>
  <div>
    <div class="bg-primary py-2 fixed-top text-white">
      <div class="container-fluid">
        <div class="d-flex justify-content-between align-items-center" style="min-height: 24px">
          <div class="small font-weight-bold">
            Terminal
          </div>
          <a v-if="isReadOnly" class="text-white" href="javascript:" @click="confirmLogout()">
            <i class="fa fa-sign-out-alt"></i>
          </a>
          <router-link v-else class="text-white" to="/home">
            <i class="fa fa-sign-out-alt"></i>
          </router-link>
        </div>
      </div>
    </div>
    <div class="container-terminal">
      <div v-show="step === 1">
        <comandas ref="comandas" terminal="true" @selecionar="selecionarComanda"/>
      </div>
      <div class="container-fluid" v-show="step === 2">
        <div class="row">
          <div class="col-md-5">
            <ul class="list-group mb-3 rounded">
              <li class="list-group-item">
                Comanda: <b>{{dados.comanda.ref_comanda}}</b>
                <div v-if="dados.comanda.id_comanda" class="float-right">
                  <a href="javascript:" title="Dados da venda" @click="openModalVenda(dados.comanda.id_comanda)">
                    <i class="fa fa-eye"></i>
                  </a>
                </div>
              </li>
              <li class="list-group-item">
                Produto:
                <b v-if="produto" class="mr-1">{{produto.nome_produto}}</b>
                <a v-if="produto" class="float-right" href="javascript:" title="Alterar produto" @click="limparProduto(true)">
                  <i class="fa fa-edit small"></i>
                </a>
              </li>
              <li class="list-group-item">
                Valor: <b v-if="produto">{{produto.valor | valor}}</b>
              </li>
            </ul>
            <div v-if="notFound">
              <div class="alert alert-danger">Produto não encontrado</div>
            </div>
            <div class="mb-3 d-none d-md-block">
              <img :class="{'bg-primary': !img_produto}" :src="img_produto || img_default" alt="Img Produto" class="img-produto">
            </div>
          </div>
          <div class="col-md-7">
            <div class="row no-gutters mb-3">
              <div class="col-6 pr-1">
                <div class="form-search" @click="limparProduto()">
                  <span class="input-icon"><i class="fa fa-search"></i></span>
                  <input id="iptProduto" v-model="termo" class="form-control mr-2" placeholder="Código do produto" type="number"
                         @keyup.enter="pesquisarProduto()"/>
                </div>
              </div>
              <div class="col-6 pl-1">
                <div v-if="id_medida === '2'" class="d-flex justify-content-between">
                  <money id="iptPeso" v-model="quantidade" :disabled="!produto"
                         class="form-control mr-2"
                         v-bind="iptPeso"
                         @keyup.native="handlerIpt"
                         @keyup.enter.native="adicionar()"
                  />
                </div>
                <div v-else>
                  <input id="iptPeso" v-model="quantidade" class="form-control mr-2" placeholder="Qtd: 0" @keyup.enter="adicionar()"/>
                </div>
              </div>
            </div>
            <div class="border bg-white height-95 mb-2 rounded" style="min-height: 350px!important;">
              <table class="table bg-white table-sm table-striped">
                <tr class="small text-center">
                  <th class="text-left">Produto</th>
                  <th>Qtd</th>
                  <th>V Unit.</th>
                  <th>Total</th>
                  <th class="text-center" style="width: 32px">&nbsp;</th>
                </tr>
                <tbody>
                <tr v-for="(p, index) in dados.produtos" class="text-center">
                  <td class="text-left">{{p.nome_produto}}</td>
                  <td>{{ p.quantidade }} {{ p.id_medida === '2' ? 'Kg' : ''}}</td>
                  <td>{{ p.produto.valor | valor }}</td>
                  <td>{{ p.valor_total | valor }}</td>
                  <td class="text-center">
                    <button class="btn btn-sm text-danger" @click="remover(index)"><i class="fa fa-trash-alt"></i></button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-bottom :opened="modal" noPad="true">
      <div class="height-100">
        <div class="container-fluid py-3">
          <cupom ref="cupom" :show-cupom="true"/>
        </div>
      </div>
      <div class="border-top text-center p-3">
        <button class="btn btn-dark px-4" @click="closeModal()">Fechar</button>
      </div>
    </modal-bottom>

    <div class="fixed-bottom bg-white border-top" v-show="step > 1">
      <div class="d-flex justify-content-between p-2">
        <button type="button" class="btn btn-dark btn-bottom" @click="limparPedido()">
          Cancelar
        </button>
        <a href="javascript:" class="btn btn-success btn-bottom" @click="finalizar()">
          Finalizar
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  import Loading from "../../components/gestor/loading";
  import ModalBottom from "../../components/gestor/ModalGestor";
  import Comandas from "@/views/comanda/comanda/Comandas";
  import PesquisarProduto from "@/views/comanda/pdv/PesquisarProduto";
  import Quantidade from "@/components/pedido-manual/Quantidade";
  import Cupom from "@/views/comanda/pdv/Cupom";

  export default {
    name: 'TerminalPesagem',
    components: {Cupom, Quantidade, PesquisarProduto, Comandas, ModalBottom, Loading},
    data() {
      return {
        token: localStorage.getItem('key'),
        empresa: localStorage.getItem('token'),
        load: false,
        step: 1,
        timeOutBalanca: null,
        loadPeso: false,

        produto: null,
        id_medida: '2',
        notFound: null,
        img_produto: null,
        img_default: null,
        termo: '',
        quantidade: '',

        modal: false,
        comanda: null,
        dados: {
          comanda: {},
          produtos: [],
        },

        iptPeso: {
          decimal: '.',
          thousands: '',
          prefix: 'Kg: ',
          suffix: '',
          precision: 3,
          masked: false
        },
      }
    },

    methods: {
      selecionarComanda(id_comanda, ref_comanda) {
        this.dados.produtos = [];
        this.dados.comanda = {
          id_comanda: id_comanda || '',
          ref_comanda: ref_comanda || '',
          tipo_comanda: '3'
        }

        this.step = 2;
        this.$nextTick(() => {
          this.termo = this.produto?.ref_produto || '';
          this.$helpers.focusElement(!this.produto ? 'iptProduto' : 'iptPeso', true);
        });
      },

      pesquisarProduto() {
        this.notFound = false;

        if (this.termo) {
          this.quantidade = '';
          this.produto = null;
          const produto = this.produtos.find(p => p.ref_produto === this.termo);

          if (produto) {
            this.produto = {
              id_tabela_preco: produto.id_tabela_preco,
              nome_produto: produto.nome_produto,
              valor_custo: produto.valor_custo,
              ref_produto: produto.ref_produto,
              id_medida: produto.id_medida,
              valor: produto.valor,
              valor_total: 0,
              quantidade: 0
            }

            this.img_produto = produto.img_produto || null;
            this.id_medida = this.produto.id_medida;

            this.$nextTick(() => {
              this.$helpers.focusElement('iptPeso', true);
            });

          } else {
            this.notFound = true;
          }
        }
      },

      mudarQtd(qtd) {
        this.produto.quantidade = qtd;
      },

      adicionar() {
        if (!this.produto || this.loadPeso) return;

        const valor_produto = this.produto.valor > 0 ? this.produto.valor : 0;

        if (valor_produto <= 0) {
          return;
        }

        this.quantidade = parseFloat(this.quantidade);

        if (this.quantidade > 0) {
          this.loadPeso = true;
          this.produto.valor_total = (this.quantidade * valor_produto).toFixed(2);
          this.dados.produtos.unshift({
            id_tabela_preco: this.produto.id_tabela_preco,
            nome_produto: this.produto.nome_produto,
            valor_total: this.produto.valor_total,
            id_medida: this.produto.id_medida,
            quantidade: this.quantidade,
            produto: {
              valor: this.produto.valor,
              valor_custo: this.produto.valor_custo,
            }
          });

          this.quantidade = '';

          if (this.produto.id_medida !== '2') {
            this.limparProduto(true);
          }

          setTimeout(() => {
            this.loadPeso = false;
          }, 500);

        } else {
          //this.loadPeso = false;
          //this.finalizar();
        }
      },

      remover(index) {
        this.dados.produtos.splice(index, 1);
        this.$helpers.focusElement(!this.produto ? 'iptProduto' : 'iptPeso');
      },

      limparProduto(focus) {
        this.produto = null;
        this.termo = '';
        this.img_produto = null;
        this.id_medida = '2';

        if (focus) {
          this.$nextTick(() => {
            this.$helpers.focusElement('iptProduto', true);
          });
        }
      },

      limparPedido() {
        this.$refs.comandas.buscarComandas();
        this.limparProduto();
        this.step = 1;
        this.dados = {
          comanda: {},
          produtos: [],
        }
      },

      finalizar() {
        if (!this.dados.produtos.length) {
          return;
        }

        this.dados.origin_pdv = true;
        this.$store.state.load = true;

        this.$http.post("pdv/pedido/" + this.token, this.dados)
          .then(res => {
            this.$store.state.load = false;

            if (res.data && res.data.id_pedido) {
              this.limparPedido();
              const id_pedido = res.data.id_pedido;
              this.$socket.emit('comanda_order', { token: this.empresa, content: { id_pedido, tipo_comanda: '3' } });

            } else {
              console.log(res);
              throw new Error(res.data);
            }

          }, res => {
            console.log(res);
            this.$store.state.load = false;
            this.$swal(res.data.msg || 'Erro temporário');
          });
      },

      lerPeso() {
        if (!this.produto || this.$store.state.load) {
          return;
        }

        if (!this.isElectron) {
          this.$swal('Por favor, instale o Gestor LeCard para usar a integração com a balança.').then(() => {
            this.$helpers.focusElement('iptPeso');
          });

          return;
        }

        this.loadPeso = true;
        this.$store.state.load = "Fazendo a leitura da balança";

        this.timeOutBalanca = setTimeout(() => {
          this.loadPeso = false;
          this.$store.state.load = false;
          this.$swal('Não foi possível fazer a leitura').then(() => {
            this.$helpers.focusElement('iptPeso');
          });
        }, 7000);

        document.dispatchEvent(new CustomEvent('comandoAcbr', { detail: "BAL.LePeso" }));
      },

      acbrReply(e) {
        clearTimeout(this.timeOutBalanca);
        this.$store.state.load = false;
        this.loadPeso = false;

        if (e.detail && e.detail.startsWith('OK:')) {
          const kilo = parseFloat(e.detail.replace('OK:','').trim().replace(',','.'));

          if (!isNaN(kilo) && kilo > 0) {
            this.quantidade = kilo.toFixed(3);
            this.adicionar();
          }

        } else if (e.detail) {
          this.$swal(e.detail).then(() => {
            this.$helpers.focusElement('iptPeso');
          })
        }
      },

      handlerIpt(evt) {
        switch (evt?.code) {
          case 'KeyP':
            this.lerPeso();
            break;

          case 'KeyF':
            this.finalizar();
            break;

          case 'Escape':
            this.limparProduto(true)
            break;
        }
      },

      openModalVenda(id_comanda) {
        this.comanda = null;
        this.$store.state.load = true;
        this.$http.get('comandas/' + this.token + '/' + id_comanda)
          .then(response => {
            this.$store.state.load = false;

            if (response.data.id_comanda) {
              this.modal = true;
              this.comanda = response.data;
              this.$refs.cupom.processarDados(this.comanda, null);
            }

          }, res => {
            this.$store.state.load = false;
          });
      },

      closeModal() {
        this.comanda = null;
        this.modal = false;
        this.$helpers.focusElement('iptPeso');
      },

      confirmLogout() {
        this.$swal({
          text: "Deseja sair do sistema?",
          buttons: ["Cancelar", "Sim"],
          dangerMode: true
        }).then((result) => {
          if (result) {
            this.logout();
          }
        });
      }
    },

    mounted() {
      document.addEventListener("acbrReply", this.acbrReply);
      this.img_default = `${this.base_cdn}/lecard-corporativo/static/imgs/default.png`;
    },

    computed: {
      usuario() {
        return this.$store.state.dataUser
      },

      produtos() {
        return this.$store.state.produtos
      },

      isReadOnly() {
        return this.$store.state.isReadOnly;
      }
    },

    beforeDestroy() {
      document.removeEventListener("acbrReply", this.acbrReply);
    }
  }
</script>

<style scoped>
  .container-terminal {
    margin-top: 54px;
    padding-bottom: 94px
  }

  .btn-bottom {
    padding: 20px 0;
    width: 140px;
  }

  .img-produto {
    width: 100%;
    height: 200px;
    object-fit: cover;
    border-radius: 12px;
    border: 4px solid #FFFFFF;
  }

  .form-search {
    position: relative;
  }

  .form-search .input-icon {
    position: absolute;
    left: 12px;
    color: #6c757d;
    font-size: 1rem;
    display: flex;
    align-items: center;
    height: 100%;
  }

  .form-search .form-control {
    padding-left: 38px;
  }
</style>
